import Axios from 'axios';

import {
	GLOBAL_CONFIG_LOADING,
	GLOBAL_CONFIG_GET,
	GLOBAL_CONFIG_ERROR,
	GLOBAL_CONFIG_CREATE_LOADING,
	GLOBAL_CONFIG_CREATE_SUCCESS,
	GLOBAL_CONFIG_CREATE_ERROR,
	GLOBAL_CONFIG_INFO_LOADING,
	GLOBAL_CONFIG_INFO,
	GLOBAL_CONFIG_INFO_ERROR,
	GLOBAL_CONFIG_GROUPS_LOADING,
	GLOBAL_CONFIG_GROUPS_GET,
	GLOBAL_CONFIG_GROUPS_ERROR,
	GLOBAL_CONFIG_GROUPS_CREATE_LOADING,
	GLOBAL_CONFIG_GROUPS_CREATE_SUCCESS,
	GLOBAL_CONFIG_GROUPS_CREATE_ERROR,
	SET_GLOBAL_CONFIG_GROUP_ID,
	GLOBAL_CONFIG_GROUPS_CHANGES,
	GLOBAL_CONFIG_FIELDS_CREATE_LOADING,
	GLOBAL_CONFIG_FIELDS_CREATE_SUCCESS,
	GLOBAL_CONFIG_FIELDS_CREATE_ERROR,
	GLOBAL_CONFIG_FIELDS_UPDATE_ERROR
} from './types';

// Actions
import { alert_set, alert_remove } from './alertActions';

// Utils
import create_query_params from '../utils/create_query_params';

export const get_global_config = (filters) => dispatch => {
	dispatch({
		type: GLOBAL_CONFIG_LOADING,
		payload: true
	});
	
	let url = process.env.REACT_APP_SERVER_URL + '/api/global/configurations?';
	let query = create_query_params(filters);
	url += query;

	Axios.get(url)
	.then((res) => {
		// console.log(res.data)
		dispatch({
			type: GLOBAL_CONFIG_GET,
			payload: res.data
		});
		dispatch({
			type: GLOBAL_CONFIG_LOADING,
			payload: false
		});
	}).catch((err) => {
		// console.log(err);
		dispatch({
			type: GLOBAL_CONFIG_ERROR,
			payload: { type: 'global_config', msg: err.message }
		});
		dispatch({
			type: GLOBAL_CONFIG_LOADING,
			payload: false
		});
	})
}

export const global_config_create = (globalConfigBody, closeModalRef, filters) => dispatch => {
	dispatch({
		type: GLOBAL_CONFIG_CREATE_LOADING,
		payload: true
	});

	let url = process.env.REACT_APP_SERVER_URL + '/api/global/configurations/create';

	Axios.post(url, globalConfigBody)
	.then((res) => {
		// console.log(res.data)
		dispatch({
			type: GLOBAL_CONFIG_CREATE_SUCCESS,
			payload: true
		});

		setTimeout(() => {
			closeModalRef.current.click();
			dispatch(get_global_config(filters));
		}, 2400);

		setTimeout(() => {
			dispatch({
				type: GLOBAL_CONFIG_CREATE_SUCCESS,
				payload: false
			});
		}, 2500);
	}).catch((err) => {
		// console.log(err);
		dispatch({
			type: GLOBAL_CONFIG_CREATE_LOADING,
			payload: false
		});

		dispatch({
			type: GLOBAL_CONFIG_CREATE_ERROR,
			payload: { type: 'global_config_create', msg: 'Error creating configuration' }
		});
	})
}

export const get_global_config_info = (config_id) => dispatch => {
	dispatch({
		type: GLOBAL_CONFIG_INFO_LOADING,
		payload: true
	});
	
	let url = process.env.REACT_APP_SERVER_URL + `/api/global/configurations/${config_id}/info`;

	Axios.get(url)
	.then((res) => {
		// console.log(res.data)
		dispatch({
			type: GLOBAL_CONFIG_INFO,
			payload: res.data
		});
		dispatch({
			type: GLOBAL_CONFIG_INFO_LOADING,
			payload: false
		});
	}).catch((err) => {
		// console.log(err);
		dispatch({
			type: GLOBAL_CONFIG_INFO_ERROR,
			payload: { type: 'global_config_info', msg: err.message }
		});
		dispatch({
			type: GLOBAL_CONFIG_INFO_LOADING,
			payload: false
		});
	})
}

export const get_global_config_groups = (filters) => dispatch => {
	dispatch({
		type: GLOBAL_CONFIG_GROUPS_LOADING,
		payload: true
	});
	
	let url = process.env.REACT_APP_SERVER_URL + '/api/global/groups?';
	let query = create_query_params(filters);
	url += query;

	Axios.get(url)
	.then((res) => {
		// console.log(res.data)
		dispatch({
			type: GLOBAL_CONFIG_GROUPS_GET,
			payload: res.data
		});
		dispatch({
			type: GLOBAL_CONFIG_GROUPS_LOADING,
			payload: false
		});
	}).catch((err) => {
		// console.log(err);
		dispatch({
			type: GLOBAL_CONFIG_GROUPS_ERROR,
			payload: { type: 'global_config_groups', msg: err.message }
		});
		dispatch({
			type: GLOBAL_CONFIG_GROUPS_LOADING,
			payload: false
		});
	})
}

export const global_config_group_create = (groupBody, closeModalRef, filters) => dispatch => {
	dispatch({
		type: GLOBAL_CONFIG_GROUPS_CREATE_LOADING,
		payload: true
	});

	let url = process.env.REACT_APP_SERVER_URL + '/api/global/groups/create';

	Axios.post(url, groupBody)
	.then((res) => {
		// console.log(res.data)
		dispatch({
			type: GLOBAL_CONFIG_GROUPS_CREATE_LOADING,
			payload: false
		});

		dispatch({
			type: GLOBAL_CONFIG_GROUPS_CREATE_SUCCESS,
			payload: true
		});

		setTimeout(() => {
			closeModalRef.current.click();
			dispatch(get_global_config_groups(filters));
		}, 2400);

		setTimeout(() => {
			dispatch({
				type: GLOBAL_CONFIG_GROUPS_CREATE_SUCCESS,
				payload: false
			});
		}, 2500);
	}).catch((err) => {
		// console.log(err);
		dispatch({
			type: GLOBAL_CONFIG_GROUPS_CREATE_LOADING,
			payload: false
		});

		dispatch({
			type: GLOBAL_CONFIG_GROUPS_CREATE_ERROR,
			payload: { type: 'global_config_group_create', msg: 'Error creating group' }
		});
	})
}

export const set_global_config_group_id = (groupId) => dispatch => {
	dispatch({
		type: SET_GLOBAL_CONFIG_GROUP_ID,
		payload: groupId
	});
}

export const global_config_groups_changes = (groupId, value) => dispatch => {
	dispatch({
		type: GLOBAL_CONFIG_GROUPS_CHANGES,
		payload: { groupId, value }
	});
}

export const global_config_field_create = (fieldBody, closeModalRef) => dispatch => {
	dispatch({
		type: GLOBAL_CONFIG_FIELDS_CREATE_LOADING,
		payload: true
	});

	let url = process.env.REACT_APP_SERVER_URL + '/api/global/fields/create';

	Axios.post(url, fieldBody)
	.then((res) => {
		// console.log(res.data)
		dispatch({
			type: GLOBAL_CONFIG_FIELDS_CREATE_SUCCESS,
			payload: true
		});

		setTimeout(() => {
			closeModalRef.current.click();
			dispatch(global_config_groups_changes(fieldBody.group, true));
		}, 2400);

		setTimeout(() => {
			dispatch({
				type: GLOBAL_CONFIG_FIELDS_CREATE_SUCCESS,
				payload: false
			});
			dispatch({
				type: GLOBAL_CONFIG_FIELDS_CREATE_LOADING,
				payload: false
			});

			dispatch(global_config_groups_changes(fieldBody.group, false));
		}, 2500);
	}).catch((err) => {
		// console.log(err);
		dispatch({
			type: GLOBAL_CONFIG_FIELDS_CREATE_LOADING,
			payload: false
		});

		dispatch({
			type: GLOBAL_CONFIG_FIELDS_CREATE_ERROR,
			payload: { type: 'global_config_field_create', msg: 'Error creating field' }
		});
	})
}

export const global_config_field_update = (fieldId, fieldBody, closeModalRef, groupId) => dispatch => {
	dispatch({
		type: GLOBAL_CONFIG_FIELDS_CREATE_LOADING,
		payload: true
	});

	let url = process.env.REACT_APP_SERVER_URL + `/api/global/fields/${fieldId}/update`;

	Axios.put(url, fieldBody)
	.then((res) => {
		// console.log(res.data)
		dispatch({
			type: GLOBAL_CONFIG_FIELDS_CREATE_SUCCESS,
			payload: true
		});

		setTimeout(() => {
			closeModalRef.current.click();
			dispatch(global_config_groups_changes(groupId, true));
		}, 2400);

		setTimeout(() => {
			dispatch({
				type: GLOBAL_CONFIG_FIELDS_CREATE_SUCCESS,
				payload: false
			});
			dispatch({
				type: GLOBAL_CONFIG_FIELDS_CREATE_LOADING,
				payload: false
			});
			dispatch(global_config_groups_changes(groupId, false));
		}, 2500);
	}).catch((err) => {
		// console.log(err);
		dispatch({
			type: GLOBAL_CONFIG_FIELDS_CREATE_LOADING,
			payload: false
		});

		dispatch({
			type: GLOBAL_CONFIG_FIELDS_UPDATE_ERROR,
			payload: { type: 'global_config_field_update', msg: 'Error creating field' }
		});
	})
}

export const global_config_field_delete = (fieldId, getFields) => dispatch => {
	let url = process.env.REACT_APP_SERVER_URL + `/api/global/fields/${fieldId}/remove`;

	Axios.delete(url)
	.then((res) => {
		// console.log(res.data)
		dispatch(alert_set('#198754', 'success', 'Field removed successfully.'));

		setTimeout(() => {
			dispatch(alert_remove());
		}, 4000);

		getFields();
	}).catch((err) => {
		// console.log(err);
		const statusCode = err.response.status;
		const errMsg = err.response.data?.error || (statusCode === 500 ? 'Internal Server Error' : 'Unknown Error')

		dispatch(alert_set('#dc3545', 'danger', `Error removing field. ${statusCode} — ${errMsg}`));

		setTimeout(() => {
			dispatch(alert_remove());
		}, 4000);
	})
}
